/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, func, object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import classNames from 'clsx';

import p from 'polyglot/polyglot';

import SpinnerIcon from 'components/SpinnerIcon/SpinnerIcon';
import ProfileHeader from 'components/ProfileHeader/ProfileHeader';
import StaffList from 'components/StaffList/StaffList';

import { getCompany as getCompanyAction } from 'actions/company';

import styles from './view.scss';

/**
 * This is the View component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class View extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    match: shape({
      path: string.isRequired,
      params: shape({
        companyId: string.isRequired,
      }).isRequired,
    }).isRequired,
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    getCompany: func.isRequired,
    company: object.isRequired,
  };

  componentDidMount() {
    const {
      auth: { token },
      match: { params },
      getCompany,
    } = this.props;

    let slug = params.slug !== 'undefined' ? params.slug : params.companyId;

    // @NOTE: always load company on view because we need to load
    // latest version after update and we need staff list.
    getCompany(token, slug);
  }

  /**
   * Render View.
   *
   * @return {Object}
   */
  render() {
    const {
      company: {
        loading,
        name,
        city,
        country,
        picture,
        website_name,
        website_url,
        staff,
      },
      match: { path },
    } = this.props;

    const containerClass = classNames(styles.container, {
      [styles.compact]: path === '/account/company/:companyId',
    });

    if (loading) {
      return (
        <section className={containerClass}>
          <div className={styles.spinner}>
            <SpinnerIcon medium />
          </div>
        </section>
      );
    }

    return (
      <section className={containerClass}>
        <ProfileHeader
          picture={picture}
          fullname={name}
          city={city}
          country={country}
          website={{
            name: website_name,
            url: website_url,
          }}
        />

        <div className={styles.section}>
          <div className={styles.sectionHeader}>
            <h2>{p.t('company.staff.title')}</h2>
          </div>

          <StaffList staff={staff} />
        </div>
      </section>
    );
  }
}

export default withRouter(
  connect(
    ({ auth, company }) => ({ auth, company }),
    {
      getCompany: getCompanyAction,
    }
  )(View)
);
